export default __webpack_public_path__ + "static/cni-2-550faa52cec67fcb254a55e4a76833d9.png";